require("./site_sectionLabelWithUnderlineDecoration.less")

export const SectionLabelWithUnderlineDecoration = ({ label }) => {
    return (
        <div className="SectionLabelWithUnderlineDecoration">{label}<span className="underline"></span></div>
    )
}

